module.exports = __webpack_public_path__ + "img/1557614076225462274.f57fb621.png";